import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AfterSubmitNavigateTo } from '@masar/common/types';
import { Router } from '@angular/router';
import { ConfirmService } from '@masar/features/confirm-dialog';

@Injectable()
export class HelperService {
    public constructor(
        private readonly translateService: TranslateService,
        private readonly router: Router,
        private readonly confirmService: ConfirmService
    ) {}

    public afterSubmitNavigationHandler(
        afterSubmitNavigateTo: AfterSubmitNavigateTo,
        link: string[],
        id: string,
        hideCases?: AfterSubmitNavigateTo[]
    ): void {
        switch (afterSubmitNavigateTo) {
            case 'list':
                this.router.navigate(link).then();
                break;
            case 'details':
                this.router.navigate([...link, 'detail', id]).then();
                break;
            case 'new':
                this.router.navigate(link).then(() => {
                    setTimeout(() => {
                        this.router.navigate([...link, 'new']).then();
                    }, 10);
                });
                break;
            case 'ask':
                this.showWhereToGoDialog(link, id, hideCases);
                break;
        }
    }

    private async showWhereToGoDialog(
        link: string[],
        id: string,
        hideCases?: AfterSubmitNavigateTo[]
    ): Promise<void> {
        const buttons = [];

        if (!hideCases?.includes('list')) {
            buttons.push({
                key: 'list',
                text: this.translateService.instant('translate_list'),
                type: 'primary' as const,
            });
        }

        if (!hideCases?.includes('new')) {
            buttons.push({
                key: 'new',
                text: this.translateService.instant('translate_add_new'),
                type: 'default' as const,
            });
        }

        if (!hideCases?.includes('details')) {
            buttons.push({
                key: 'details',
                text: this.translateService.instant('translate_show_details'),
                type: 'default' as const,
            });
        }

        const result = await this.confirmService.multiButton({
            title: this.translateService.instant(
                'translate_where_do_you_want_to_go'
            ),
            text: this.translateService.instant(
                'translate_the_page_will_be_automatically_redirect_if_no_action_taken'
            ),
            allowOutsideClick: false,
            timer: 10_000,
            timerProgressBar: true,
            buttons,
        });

        let afterSubmitNavigateTo: AfterSubmitNavigateTo;

        if (result === 'list') {
            afterSubmitNavigateTo = 'list';
        } else if (result === 'new') {
            afterSubmitNavigateTo = 'new';
        } else {
            afterSubmitNavigateTo = hideCases?.includes('details')
                ? 'list'
                : 'details';
        }

        this.afterSubmitNavigationHandler(afterSubmitNavigateTo, link, id);
    }
}
